<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Presupuesto mensual: Otros ingresos"></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Presupuesto mensual: Otros ingresos'" videoEmbed="ADMINISTRACIONDINERO25 PresupuestoMensualOtrosIngresos.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 mt-4>
        <p>
          En este cuadro debe escribir los ingresos mensuales que recibe por otros conceptos diferentes al salario. <br>
          Importante: no incluya puntos ni comas.
        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <ui-calculadora 
      :mostrarTotal="true"
      :formulario="ingresoSalario"
      :nombresCols="nombres"
      :resultadoDiferencia="resultadoDiferencia"
      :resultadoTotal="resultadoTotal"
      ></ui-calculadora>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "La primera especifica el <strong>tipo de ingreso.</strong>",
        "En la segunda <strong>debe digitar el valor real que recibe durante el mes.</strong>",
        "La tercera columna es opcional y se refiere al dinero que usted espera que ingrese para un mes determinado",
        "La última columna calcula la diferencia automáticamente, en caso de haber diligenciado los Valores Planeados. "
      ],
      nombres: [
        "<span class='font-red'>Otros ingresos mensuales</span>",
        "<span class='font-red'>Valor real,</span><br> (Lo efectivamente recibido durante el mes)",
        "<span class='font-red'>Valor planeado,</span><br> (El esperado inicialmente en el presupuesto mensual)",
        "<span class='font-red'>Diferencia mensual</span>"
      ]
    };
  },
  computed: {
    ingresoSalario() {
      return this.$store.state.otrosIngresoSalario;
    },
    resultadoDiferencia() {
      return this.$store.getters.OtrosIngresoSalarioDiferencia;
    },
    resultadoTotal() {
      return this.$store.getters.OtrosIngresoSalarioTotal;
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-25.vue?4cd72058